import styled from '@emotion/styled'
import { Card, Box, IconButton, Typography, Chip } from '@mui/material'

export const InterventionCard = styled(Card)`
  margin-bottom: 16px;
  padding: 16px;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`

export const StatusIcon = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const UserInfo = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const ActionButtons = styled(Box)`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`

export const TabPanel = styled(Box)`
  padding: 24px 0;
`

export const MessagePreview = styled(Box)`
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin: 8px 0;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-wrap;
`

export const InterventionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const InterventionContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FeedbackSection = styled(Box)`
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  margin-top: 16px;
`

export const ActionButton = styled(IconButton)`
  &:hover {
    background-color: #f0f0f0;
  }
`

export const PrimaryActionSection = styled(Box)`
  margin-top: 24px;
  padding: 24px;
  background-color: #fafafa;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
`

export const SecondaryActionsSection = styled(Box)`
  margin-top: 16px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
`

export const GuidanceSection = styled(Box)`
  margin-bottom: 16px;
`

export const OrganizationalSection = styled(Box)`
  margin-top: 16px;
`

export const OrganizationTypeLabel = styled(Box)`
  margin-bottom: 8px;
`

export const OrganizationChipsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const NoRelationshipsMessage = styled(Box)`
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
`

export const SectionTitle = styled(Typography)`
  margin-bottom: 8px;
  font-weight: 600;
`

export const OrganizationLabel = styled(Typography)`
  font-weight: 500;
  margin-bottom: 8px;
`

export const NoRelationshipsText = styled(Typography)`
  font-style: italic;
`

export const OrganizationChip = styled(Chip)`
  font-size: 0.75rem;

  &.MuiChip-colorSecondary {
    color: #2c3e50;
    font-weight: 500;
  }
`
